<template>
  <div v-if="worker(retired.id)" class=" d-flex justify-center align-center" style="width:100%">
    <v-card hover class="box-card pa-4">
      <v-avatar class="profile" color="grey">
        <v-img
          :aspect-ratio="1 / 1"
          v-if="worker(retired.id).image.length > 0 && !setInitials"
          :src="baseUrl(retired.id)"
          v-on:error="setInitials = true"
        />
        <span v-else class="white--text header-fg-alt" v-text="initials(retired.id)" />
      </v-avatar>
      <div class="bottom-section d-flex">
        <h6 v-text="name(retired.id)" />
        <p class="position body-2 mt-4 pl-1" v-text="retired.biografia" />
      </div>
    </v-card>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: "RetiredCell",
  props: {
    retired: Object
  },
  methods: {
    name(id) {
      const worker = this.worker(id);
      return worker.name + " " + worker.lastName;
    },

    initials(id) {
      const worker = this.worker(id);
      return worker.name.charAt(0) + worker.lastName.charAt(0);
    },
    baseUrl(id) {
      const worker = this.worker(id);
      const fileName = worker.image;
      return $(location).attr("origin") + "/archivos/personal/" + fileName;
    },
    worker(id) {
      const { $info } = this;
      return $info.about.personal.find(worker => worker.id === id);
    }
  },
  computed: {
    // worker() {
    //   const { $info, retired } = this;
    //   return $info.about.personal.find(worker => worker.id === retired.id);
    // },
  },
  beforeMount: function() {},
  data() {
    return {
      setInitials: false
    };
  }
};
</script>
<style lang="scss" scoped>
.header-fg-alt {
  color: #222a42;
  line-height: 1.05;
  font-weight: 400;
  font-size: 47px;
  font-family: "Poppins";
  text-transform: capitalize;
}
.bottom-section {
  // flex: 1;
  padding: 0;
  margin-top: 20px;
  text-align: center;
  flex-direction: column;
  .position {
    font-size: 10px;
    text-transform: none;
    text-align: left;
    opacity: 0.6;
  }
  // * {
  //   text-align: center;
  // }
}

.profile {
  height: 140px !important;
  width: 140px !important;
}
.box-card {
  * {
    transition: all 0.3s;
  }
  width: 295px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 450px;
  margin: 10px;
  display: flex;
}
</style>
